<aca-page-layout>
  <div class="aca-page-layout-header">
    <div class="aca-header-container">
      <h1 class="aca-page-title">
        {{ (selectedRowItemsCount < 1 ? config.title : 'APP.HEADER.SELECTED') | translate: { count: selectedRowItemsCount } }}
      </h1>
      <aca-toolbar [items]="actions" />
    </div>
  </div>

  <div class="aca-page-layout-content">
    <div class="aca-main-content alg-virtual-files">
      <as-split direction="horizontal" [disabled]="!previewOpened" (dragEnd)="onDragEnd($event)">
        <as-split-area [size]="previewOpened ? paneSizes[0] : 100" [minSize]="isSmallScreen ? 0 : 15">
          <adf-document-list
            #documentList
            acaDocumentList
            acaContextActions
            [currentFolderId]="config.rootId"
            [selectionMode]="'multiple'"
            [multiselect]="true"
            [navigate]="false"
            [sorting]="view === 'trashcan' ? ['archivedAt', 'desc'] : ['modifiedAt', 'desc']"
            [preselectNodes]="selectedNodesState?.nodes"
            [sortingMode]="'client'"
            [imageResolver]="imageResolver"
            [displayCheckboxesOnHover]="true"
            [isResizingEnabled]="true"
            [blurOnResize]="false"
            (selectedItemsCountChanged)="onSelectedItemsCountChanged($event)"
            (node-dblclick)="openNode($event)"
            (name-click)="openNode($event)"
          >
            <adf-custom-empty-content-template>
              <adf-empty-content [icon]="config.icon" [title]="config.emptyTitle" [subtitle]="config.emptyText" />
            </adf-custom-empty-content-template>

            <data-columns>
              <ng-container *ngFor="let column of columns; trackBy: trackByColumnId">
                <ng-container *ngIf="column.template && !(column.desktopOnly && isSmallScreen)">
                  <data-column
                    [id]="column.id"
                    [key]="column.key"
                    [title]="column.title"
                    [type]="column.type"
                    [format]="column.format"
                    [class]="column.class"
                    [sortable]="column.sortable"
                    [isHidden]="column.isHidden"
                    [draggable]="column.draggable"
                    [resizable]="column.resizable"
                    [sortingKey]="column.sortingKey || column.key"
                  >
                    <ng-template let-context><adf-dynamic-column [id]="column.template" [context]="context" /></ng-template>
                  </data-column>
                </ng-container>
                <data-column
                  *ngIf="!column.template && !(column.desktopOnly && isSmallScreen)"
                  [id]="column.id"
                  [key]="column.key"
                  [title]="column.title"
                  [type]="column.type"
                  [format]="column.format"
                  [class]="column.class"
                  [sortable]="column.sortable"
                  [isHidden]="column.isHidden"
                  [draggable]="column.draggable"
                  [resizable]="column.resizable"
                  [sortingKey]="column.sortingKey || column.key"
                />
              </ng-container>
              <data-column
                id="alg.commentaires"
                key="properties.fm:commentCount"
                title="Commentaires"
                class="alg-comments-column adf-ellipsis-cell"
                [sortable]="false"
                [draggable]="true"
                [resizable]="true"
                [isHidden]="false"
              >
                <ng-template let-entry>
                  <div class="comment-count" *ngIf="commentColumn.getCount(entry.row) > 0">
                    <button type="button" class="comment-count__button"
                            [attr.aria-label]="'Ouvrir les commentaires (' + commentColumn.getCount(entry.row) + ')'"
                            (click)="commentColumn.open($event, entry.row, documentList)">
                      <mat-icon>comment</mat-icon>
                    </button>
                    <span class="comment-count__text">{{ commentColumn.getCount(entry.row) }}</span>
                  </div>
                </ng-template>
              </data-column>
            </data-columns>
          </adf-document-list>
        </as-split-area>

        <as-split-area [visible]="previewOpened" [size]="previewOpened ? paneSizes[1] : 0" [minSize]="isSmallScreen ? 0 : 15">
          <div class="alg-virtual-preview" *ngIf="previewOpened">
            <adf-alfresco-viewer
              *ngIf="view !== 'shared'"
              class="alg-virtual-preview__viewer"
              [nodeId]="previewNodeId"
              [overlayMode]="false"
              [showToolbar]="true"
              closeButtonPosition="left"
              [showLeftSidebar]="false"
              [showRightSidebar]="false"
              [hideInfoButton]="isSmallScreen"
              [allowPrint]="true"
              [allowDownload]="true"
              [allowFullScreen]="true"
              (showViewerChange)="closePreview()"
            />
            <adf-alfresco-viewer
              *ngIf="view === 'shared'"
              class="alg-virtual-preview__viewer"
              [sharedLinkId]="previewSharedLinkId"
              [overlayMode]="false"
              [showToolbar]="true"
              closeButtonPosition="left"
              [showLeftSidebar]="false"
              [showRightSidebar]="false"
              [hideInfoButton]="isSmallScreen"
              [allowPrint]="true"
              [allowDownload]="true"
              [allowFullScreen]="true"
              (showViewerChange)="closePreview()"
            />
            <button
              *ngIf="view === 'shared'"
              class="alg-virtual-preview__shared-close"
              mat-icon-button
              title="Fermer la prévisualisation"
              aria-label="Fermer la prévisualisation"
              (click)="closePreview()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </as-split-area>
      </as-split>

      <adf-pagination acaPagination [target]="documentList" />
    </div>

    <div class="aca-sidebar" *ngIf="infoDrawerOpened$ | async">
      <aca-info-drawer [node]="selection.last" />
    </div>
  </div>
</aca-page-layout>
